module.exports = __webpack_public_path__ + "img/282-90c60d.png";